import { EWhTaskMainTabs, type IWhTaskMainTabs } from './types';

export const getTabsList = (isInvoicesTabVisible: boolean, isExpensesTabVisible: boolean): IWhTaskMainTabs[] => [
  {
    key: EWhTaskMainTabs.items,
    label: 'Items',
  },
  {
    key: EWhTaskMainTabs.documents,
    label: 'Documents',
  },
  ...(isInvoicesTabVisible
    ? [
        {
          key: EWhTaskMainTabs.invoices,
          label: 'Invoices',
        },
      ]
    : []),
  ...(isExpensesTabVisible
    ? [
        {
          key: EWhTaskMainTabs.expenses,
          label: 'Expenses',
        },
      ]
    : []),
];
